import { EditUserFlightPreferencesForm, UserFlightPreferences } from "Bands/containers";
import { useState } from "react";
import { copy } from "shared/assets";
import { Plane } from "shared/assets/icons";
import { Card, Modal } from "shared/components";

export const FlightPreferences = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Card icon={Plane} title={copy.userFlightPreferences.title}>
      <UserFlightPreferences handleShowModal={setShowModal} />
      {showModal && (
        <Modal
          icon={Plane}
          title={copy.userFlightPreferences.title}
          handleClose={() => setShowModal(false)}
        >
          <EditUserFlightPreferencesForm handleClose={() => setShowModal(false)} />
        </Modal>
      )}
    </Card>
  );
};
